// Contentful
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

// Components
import Author from '../Author/Author';
import Pattern from '../Pattern/Pattern';

const PlaybookHeader = (props) => {
  const { title, bodyText, author, figure, modifier, pattern, url } = props;

  return (
    <div className={`OgImage ${figure?.modifier || ''} ${modifier || ''}`}>
      <div className="OgImage-inner">
        {(title || author || bodyText) && (
          <div className="OgImage-content">
            <svg className="OgImage-siteLogo">
              <use xlinkHref="#logo-mutiny-text" />
            </svg>
            {title && <h1 className="OgImage-title">{title}</h1>}
            {bodyText && <div className="OgImage-description">{documentToReactComponents(bodyText)}</div>}
            {url && (
              <div className="OgImage-description">
                <p>{url}</p>
              </div>
            )}
            {author && (
              <div className="OgImage-author">
                <Author {...author} modifier="Author--ogImage" />
                <img className="OgImage-companyLogo" alt={`Logo ${author.company}`} src={figure.logo} />
              </div>
            )}
          </div>
        )}
        {figure && (
          <>
            <div className="OgImage-illustration">
              <div className="OgImage-figure">
                {figure.layers.map((layer, index) => (
                  <svg className="OgImage-figureLayer" key={`OgImage-figureLayer--${index}`}>
                    <use xlinkHref={`#${layer}`} />
                  </svg>
                ))}
              </div>
            </div>
          </>
        )}
        {pattern && (
          <div className="OgImage-pattern">
            <Pattern modifier={pattern} />
          </div>
        )}
      </div>
    </div>
  );
};

export default PlaybookHeader;
